import React from "react";
import { Row, Col } from "react-bootstrap";

export default function Placeholder() {
  return (
    <div className="placeholder">
    </div>
  );
}
